module.exports = __webpack_public_path__ + "static/media/crypto.d94131e3.gif";